import { initAdv, injectAdv } from '@sky-uk/sky-adv';

import { isMobile } from '../../utils/device-utils';
import { insertAfter } from '../../utils/dom-utils';
import { initAdvLabels } from '../../utils/adv-helper';
import { isNewsYouCanUsePage } from '../../utils/aem-utils';
import { forEach } from '../../utils/array-utils';

const SMALL_BOTTOM_SPACING_CLASSNAME = 'l-spacing-s';

/**
 * Inject new adv inread with video
 * @param {HTML Node} $advTopDataNode
 * @param {HTML Node} paragraph
 */
const injectAdvVideoInRead = ($advInReadVideoDataNode, paragraph) => {
  console.info('[ADV ARTICLE] start video in read adv init');
  paragraph.classList.add(SMALL_BOTTOM_SPACING_CLASSNAME);

  const $advContainer = document.createElement('div');
  insertAfter(paragraph, $advContainer);

  injectAdv($advInReadVideoDataNode, $advContainer);
  initAdv($advInReadVideoDataNode);
};

/**
 * Inject adv top in article pages.
 * If paragraph is passed, we inject adv on sidebar (desktop) or after first/second par (mobile) --> i.e. Canonical Article pages
 * If NO paragraph is passed, we inject always on sidebar (mobile + desktop) --> i.e. Article on News U Can Use pages
 * @param {HTML Node} $advTopDataNode
 * @param {HTML Node} paragraph
 */
const injectAdvTopArticle = ($advTopDataNode, paragraph) => {
  console.info('[ADV ARTICLE] init adv top article ');

  if (paragraph && isMobile()) {
    console.info('[ADV ARTICLE] inject adv on mobile and move it after the 1st paragraph');
    const $advMpuTopMobile = document.querySelector('#adv-mpu-top-mobile');
    // Fallback to the first adv-mpu-top-mobile if the parent is not a shifting container
    const $advTopMobileWrapper = $advMpuTopMobile?.parentElement?.classList.contains('s-adv-shifting-container')
      ? $advMpuTopMobile.parentElement
      : $advMpuTopMobile;
    insertAfter(paragraph, $advTopMobileWrapper);
    const $advTopMobileContainer = document.querySelector('#advTopMobile');
    injectAdv($advTopDataNode, $advTopMobileContainer);
  }
  if (paragraph && !isMobile()) {
    console.info('[ADV ARTICLE] inject adv top article on desktop');
    const $advTopDesktopContainer = document.querySelector('#adv-top');
    injectAdv($advTopDataNode, $advTopDesktopContainer);
  }
  if (!paragraph) {
    console.info('[ADV ARTICLE] inject adv top article with no paragraphs');
    const $advTopMobileDesktopContainer = isMobile()
      ? document.querySelector('#advTopMobile')
      : document.querySelector('#adv-top');
    injectAdv($advTopDataNode, $advTopMobileDesktopContainer);
  }

  initAdv($advTopDataNode);
};

export const init = ({ $advTopDataNode, $advInReadVideoDataNode, $advInArticleDataNode }) => {
  initAdvLabels();

  if (isNewsYouCanUsePage()) {
    if ($advTopDataNode) {
      injectAdvTopArticle($advTopDataNode);
    }
    if ($advInArticleDataNode) {
      const $advInArticleContainers = document.querySelectorAll('.c-adv-in-article');
      forEach(($advInArticleContainer) => {
        injectAdv($advInArticleDataNode, $advInArticleContainer);
      })($advInArticleContainers);
      initAdv($advInArticleDataNode);
    }
    return;
  }

  /**
   From here IS NOT news-you-can-use page
  */
  const paragraphNodes = document.querySelectorAll('.j-article-section p');
  const paragraphs = Array.from(paragraphNodes).filter((item) => item.innerHTML.length > 0);

  if ($advTopDataNode) {
    const firstParagraph = paragraphs?.[0];
    injectAdvTopArticle($advTopDataNode, firstParagraph);
  }

  if ($advInReadVideoDataNode && paragraphs.length > 2) {
    const secondParagraph = paragraphs[1];
    injectAdvVideoInRead($advInReadVideoDataNode, secondParagraph);
  }
};
